import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import { useCallback, useEffect, useLayoutEffect, useMemo } from 'react';
import { useRefFrom } from 'use-ref-from';
export default function createPropagation() {
  var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var rendering = false;
  var allowPropagateDuringRender = init.allowPropagateDuringRender;
  var listeners = new _Set();
  var addListener = function addListener(listener) {
    return void listeners.add(listener);
  };
  var removeListener = function removeListener(listener) {
    return void listeners.delete(listener);
  };
  var usePropagate = function usePropagate() {
    rendering = true;
    useLayoutEffect(function () {
      rendering = false;
    });
    return function (value) {
      if (rendering && !allowPropagateDuringRender) {
        return console.warn('use-propagate: The propagate callback function should not be called while rendering, ignoring the call.');
      }
      _forEachInstanceProperty(listeners).call(listeners, function (listener) {
        return listener(value);
      });
    };
  };
  return {
    useListen: function useListen(listener) {
      var listenerRef = useRefFrom(listener);
      var wrappingListener = useCallback(function (value) {
        return listenerRef.current(value);
      }, [listenerRef]);
      useMemo(function () {
        return addListener(wrappingListener);
      }, [wrappingListener]);
      useEffect(function () {
        return function () {
          return removeListener(wrappingListener);
        };
      }, [wrappingListener]);
    },
    usePropagate: usePropagate
  };
}
//# sourceMappingURL=createPropagation.js.map